// Purify HTML
import DOMPurify from "dompurify"

/**
 * Rewrites mangopay urls to have the correct returnUrl
 *
 * TODO: This is a hack that should be implemented in the backend instead!
 * @param verification_url
 * @returns
 */
export function rewriteMangoPayReturnUrlToCurrentUrl(verification_url: string) {
	const url = new URL(verification_url)
	const currentUrl = window.location.href
	url.searchParams.set("returnUrl", encodeURIComponent(currentUrl))
	return url.toString()
}

// Export
export { DOMPurify }
